import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import CompleteSingle from "./CompleteSingle"
export default function () {
    const todos = useSelector( (state) => state.todos );
    const filters = useSelector( ( state ) => state.filters );

    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(fetchTodos);
    }, [dispatch] );

   

    return (
        <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
            {todos
                .filter( (todo) => todo.completed === true)
                .map((todo) => (
                    <CompleteSingle todo={todo} key={todo.id} />
                ))}
        </div>
    )
}